<template>
  <section class="visitanos" id="visitanos">
    <h3 class="title-section">Visitanos en</h3>
    <div class="visitanos-mapa">
      <iframe
        src="https://www.google.com/maps/embed?pb=!4v1691106129345!6m8!1m7!1sgGL-ZeEl712Rntv-dCZXJQ!2m2!1d18.4606000434244!2d-97.38265393226985!3f133.62042184802388!4f-11.102728996673164!5f0.7820865974627469"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </section>
</template>

<script setup></script>
